import { Pipe } from '@angular/core';
import { isNumberFinite } from '../helpers/helpers';
var RadiansPipe = (function () {
    function RadiansPipe() {
    }
    RadiansPipe.prototype.transform = function (degrees) {
        if (!isNumberFinite(degrees)) {
            return NaN;
        }
        return degrees * Math.PI / 180;
    };
    RadiansPipe.decorators = [
        { type: Pipe, args: [{ name: 'radians' },] },
    ];
    /** @nocollapse */
    RadiansPipe.ctorParameters = function () { return []; };
    return RadiansPipe;
}());
export { RadiansPipe };
//# sourceMappingURL=radians.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/radians.js
// module id = 452
// module chunks = 4